<div class="tabs-block">
  <div class="tabs-block__header">
    <div class="tabs-block__header-item tabs-block__header-left-expanded">
      <ng-content select="left-expanded-block"></ng-content>
    </div>
    <div
      class="tabs-block__header-item tabs-block__header-item-tabs header-item-tabs--left"
      [ngClass]="{
        'header-item-tabs--center': justifyContent === 'center',
        'header-item-tabs--right': justifyContent === 'right'
      }"
    >
      <button class="header-item__tab" *ngFor="let tab of tabs" [disabled]="tab.disabled" (click)="selectTab(tab)" [ngClass]="{ 'header-item__tab--active': tab.active }">
        <a
          class="link"
          [ngClass]="{
            'link--no-underline': tab.active,
            'link--dotted-gray-dark': !tab.active
          }"
        >
          {{ tab.title }}
        </a>
      </button>
    </div>
    <div class="tabs-block__header-item tabs-block__header-right-expanded">
      <ng-content select="right-expanded-block"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>
</div>
